import { inject } from "@nuxtjs/composition-api";

const MAP_INSTANCE_KEY = `l7-map`;

export function useL7Scene() {
  return inject(MAP_INSTANCE_KEY);
}


